import { render, staticRenderFns } from "./FormImages.vue?vue&type=template&id=61b5ac14"
import script from "./FormImages.vue?vue&type=script&lang=ts"
export * from "./FormImages.vue?vue&type=script&lang=ts"
import style0 from "./FormImages.vue?vue&type=style&index=0&id=61b5ac14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports